<div class="controlMessage" *ngIf="messages?.length">
                    <div class="msg" *ngFor="let msg of messages; trackBy: trackMessage">{{msg|trans}}</div>
                </div>